import {addDays} from 'date-fns';
import {useCookies} from 'react-cookie';
import {useTranslation} from 'react-i18next';
import {i18n} from 'src/i18n';

const langSelectionCookieKey = 'mv-lang-selection';

const defaultCookieOptions = {
    domain: '.mittvaccin.se',
    path: '/',
    expires: addDays(new Date(), 30),
    secure: true
};

const defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE;
const supportedLanguages = process.env.REACT_APP_SUPPORTED_LANGUAGES?.split(',') ?? [];

const changeLanguage = (lng: string, cookies: any, setCookie: any) => {
    i18n.changeLanguage(lng);

    const selectedLangaugeFromCookie = cookies[langSelectionCookieKey];
    if (selectedLangaugeFromCookie === lng) {
        return;
    }

    setCookie(langSelectionCookieKey, lng, defaultCookieOptions);
};

type PickSiteLanguageProps = {
    size?: string;
};

export function PickSiteLanguage({size = 'default'}: PickSiteLanguageProps) {
    const {t} = useTranslation();
    const [cookies, setCookie] = useCookies();

    const selectedLanguage = cookies[langSelectionCookieKey] ?? defaultLanguage;
    const className = size == 'big' ? 'navbar__language-selector-big' : 'navbar__language-selector';

    return (
        <select
            name='languageSelection'
            aria-label={`${t('general.choose_language')}`}
            className={className}
            defaultValue={selectedLanguage}
            onChange={(e) => {
                changeLanguage(e.target.value, cookies, setCookie);
            }}
        >
            {supportedLanguages?.map((language) => {
                return (
                    <option key={language} value={language}>
                        {t(`general.${language}`)}
                    </option>
                );
            })}
        </select>
    );
}
